import { connect } from 'react-redux';
import { ACTIONS } from '../../actions/reducers';
import { Orders as OrdersComponent } from './orders.component';
import { retrieveData } from '../dashboard.actions';

export const setOrders = orders => dispatch => {
  dispatch({ type: ACTIONS.SET_ORDERS, orders });
}

export const Orders = connect(sState => ({ sState }), { retrieveData })(OrdersComponent);